import script from "./CompanyIntro.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyIntro.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyIntro.vue?vue&type=style&index=0&id=7f53b793&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f53b793"]])

export default __exports__